<!-- (ngSubmit)="f.form.valid && processData()" -->
<form name="form" #f="ngForm" novalidate (ngSubmit)="processData(f.form.value)">
  <div class="row">
    <div class="col-md-6">
      <div class="form-group padding-right-10">
        <!-- ABOUT US: TEAM -->
        <mat-form-field>
          <mat-select placeholder="Select section" name="section" [(ngModel)]="iapData.subsectionName" required
            (selectionChange)="onSectionChange($event.value)">
            <mat-option *ngFor="let section of sections" [value]="section?.subSectionName">
              {{ section?.subSectionName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div *ngIf="iapData.subsectionName === 'Banners'&& iapData.bannerData">
    <div class="row">
      <div class="form-group padding-right-10 col-md-12">
        <app-file-input (fileChange)="onFileChange($event, 'desktop')" *ngIf="!iapData.bannerData.webBannerImagePath"
          [(ngModel)]="fileName" name="fileName" placeholder="Upload Web Image" required>
          <button type="button" mat-raised-button color="primary">
            Choose
          </button>
        </app-file-input>
     
        <ng-template [ngIf]="iapData.bannerData.webBannerImagePath">
          <mat-form-field>
            <input disabled matInput placeholder="Image" [(ngModel)]="iapData.bannerData.webBannerImagePath" name="Image" />
            <button class="margin-right-30" mat-button matSuffix mat-icon-button type="button"
              (click)="iapData.bannerData.webBannerImagePath = ''">
              <mat-icon>clear</mat-icon>
            </button>
          </mat-form-field>

        </ng-template>
        <p>Note: Please upload image with resolution 1680*565</p>

      </div>
    </div>
    <!-- uncomment if u want to pass separate field for mobile -->
    <div class="row">
      <div class="form-group padding-right-10 col-md-12">
        <app-file-input (fileChange)="onFileChange($event, 'mobile')" *ngIf="!iapData.bannerData.webBannerImagePath"
          [(ngModel)]="mobfileName" name="mobfileName" placeholder="Upload Mobile Image" required>
          <button type="button" mat-raised-button color="primary">
            Choose
          </button>
        </app-file-input>
        <ng-template [ngIf]="iapData.bannerData.webBannerImagePath">
          <mat-form-field>
            <input disabled matInput placeholder="Image" [(ngModel)]="iapData.bannerData.webBannerImagePath" name="Image" />
            <button class="margin-right-30" mat-button matSuffix mat-icon-button type="button"
              (click)="iapData.bannerData.webBannerImagePath = ''">
              <mat-icon>clear</mat-icon>
            </button>
          </mat-form-field>
        </ng-template>
        <p>Note: Please upload image with resolution 390*430</p>

      </div>
    </div>

    <div class="row">

      <div class="col-md-6">
        <div class="form-group">
          <mat-form-field name="url">
            <input matInput placeholder="Enter clickable URL" name="url" [(ngModel)]="iapData.bannerData.clickableUrl" />
          </mat-form-field>

        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <!-- CAREER:JOB TITLE-->
          <mat-form-field>
            <input matInput placeholder="Enter Sequence " [(ngModel)]="iapData.bannerData.sequence" name="sequence"
              #sequence="ngModel" (keypress)="allowOnlyNumbers($event)" required />
          </mat-form-field>
        </div>
      </div>

    </div>


  </div>

  <div *ngIf="iapData.subsectionName === 'Videos' && iapData.videoData">
        <div class="row">
      <div class="form-group padding-right-10 col-md-12">
        <app-file-input (fileChange)="onFileChange($event, 'videoThumbnail')" *ngIf="!iapData.videoData.imagePath"
          [(ngModel)]="videoThumbnailName" name="videoThumbnailName" placeholder="Upload Thumbnail"
          required>
          <button type="button" mat-raised-button color="primary">
            Choose
          </button>
        </app-file-input>
        <ng-template [ngIf]="iapData.videoData.imagePath">
          <mat-form-field>
            <input disabled matInput placeholder="imagePath" [(ngModel)]="iapData.videoData.imagePath"
              name="imagePath" />
            <button class="margin-right-30" mat-button matSuffix mat-icon-button type="button"
              (click)="iapData.videoData.imagePath = ''">
              <mat-icon>clear</mat-icon>
            </button>
          </mat-form-field>
        </ng-template>
        <p>Note: Please upload image with resolution 472*270</p>

      </div>
    </div>
    <div class="row">
      <!--TITLE-->
      <div class="col-md-6">
        <div class="form-group">
          <mat-form-field>
            <input matInput placeholder="Enter Title" [(ngModel)]="iapData.videoData.title" name="title" #title="ngModel"
              required />
          </mat-form-field>
        </div>
      </div>
      <!--URL-->
      <div class="col-md-6">
        <div class="form-group">
          <mat-form-field>
            <input matInput placeholder="Enter YouTube URL" [(ngModel)]="iapData.videoData.youtubeLink" name="youtubeLink"
              #youtubeLink="ngModel" required />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="iapData.subsectionName === 'Infographics' && iapData.infoData">
    <div class="row">
      <div class="form-group padding-right-10 col-md-12">
        <app-file-input (fileChange)="onFileChange($event, 'infoImage')" *ngIf="!iapData.infoData.filePath"
          [(ngModel)]="infographicImageName" name="infographicImageName" placeholder="Upload Image" required>
          <button type="button" mat-raised-button color="primary">
            Choose
          </button>
        </app-file-input>
        <ng-template [ngIf]="iapData.infoData.filePath">
          <mat-form-field>
            <input disabled matInput placeholder="Image" [(ngModel)]="iapData.infoData.filePath" name="Image" />
            <button class="margin-right-30" mat-button matSuffix mat-icon-button type="button"
              (click)="iapData.infoData.filePath = ''">
              <mat-icon>clear</mat-icon>
            </button>
          </mat-form-field>
        </ng-template>
        <p>Note: Please upload image with resolution 1180 * 1508</p>

      </div>
    </div>
    <div class="row">
      <div class="form-group padding-right-10 col-md-12">
        <app-file-input (fileChange)="onFileChange($event, 'infoThumbnail')" *ngIf="!iapData.infoData.thumbnailPath"
          [(ngModel)]="infographicThumbnailName" name="infographicThumbnailName" placeholder="Upload Thumbnail"
          required>
          <button type="button" mat-raised-button color="primary">
            Choose
          </button>
        </app-file-input>
        <ng-template [ngIf]="iapData.infoData.thumbnailPath">
          <mat-form-field>
            <input disabled matInput placeholder="thumbnailPath" [(ngModel)]="iapData.infoData.thumbnailPath"
              name="thumbnailPath" />
            <button class="margin-right-30" mat-button matSuffix mat-icon-button type="button"
              (click)="iapData.infoData.thumbnailPath = ''">
              <mat-icon>clear</mat-icon>
            </button>
          </mat-form-field>
        </ng-template>
        <p>Note: Please upload image with resolution 472*270</p>

      </div>
    </div>
  </div>

  <div *ngIf="iapData.subsectionName === 'Articles' && iapData.blogData">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <mat-form-field>
            <input matInput placeholder="Enter Title" [(ngModel)]="iapData.blogData.title" name="title" #title="ngModel"
              required />
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-6">
      </div>

    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <div class="align-h margin-bottom-10">
            <h5 class="margin-bottom-0">Article Content</h5>
            <span>(description)</span>
          </div>
          <angular-editor [placeholder] [(ngModel)]="iapData.blogData.content" name="content" #content="ngModel"
            required [config]="editorConfig"></angular-editor>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="form-group padding-right-10 col-md-12">
        <app-file-input (fileChange)="onFileChange($event, 'articleThumbnail')" *ngIf="!iapData.blogData.imagePath"
          [(ngModel)]="articleThumbnailName" name="articleThumbnailName" placeholder="Upload Thumbanail" required>
          <button type="button" mat-raised-button color="primary">
            Choose
          </button>
        </app-file-input>
        <ng-template [ngIf]="iapData.blogData.imagePath">
          <mat-form-field>
            <input disabled matInput placeholder="articleThumbnailPath" [(ngModel)]="iapData.blogData.imagePath"
              name="articleThumbnailPath" />
            <button class="margin-right-30" mat-button matSuffix mat-icon-button type="button"
              (click)="iapData.blogData.imagePath = ''">
              <mat-icon>clear</mat-icon>
            </button>
          </mat-form-field>
        </ng-template>
        <p>Note: Please upload image with resolution 472*270</p>

      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group padding-right-10" >
          <mat-form-field>
            <mat-select placeholder="Select Similar Article" name="articles"
              (selectionChange)="selectSimilar($event.value)" [(ngModel)]="selectedValue" >
              <mat-option *ngFor="let article of articlesArray " [value]="article">
                {{ article?.title }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="mt-3">
      <div
        *ngFor="let selectedArticle of iapData.blogData.similarArticles"
        class="badge badge-info d-inline-flex align-items-center m-1"
      >
        {{ selectedArticle.title }}
        <button
          type="button"
          class="btn btn-sm btn-link text-white ml-2 p-0"
          (click)="removeTitle(selectedArticle.id)"
        >
          &times;
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="iapData.subsectionName === 'Text' && iapData.textData">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group padding-right-10">
          <!-- ABOUT US: TEAM -->
          <mat-form-field>
            <mat-select placeholder="Select section" name="subSection" [(ngModel)]="iapData.textData.sectionName" required
              (selectionChange)="onSubSectionChange($event.value)">
              <mat-option *ngFor="let subsection of subSections" [value]="subsection?.sectionName">
                {{ subsection?.sectionName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <ng-template #formTemplate>
    <div class="row">
      <div class="col-md-12">
          <div class="form-group">
            <mat-form-field>
              <input matInput placeholder="Enter Title" [(ngModel)]="iapData.textData.title" name="title" #title="ngModel" maxlength="100" 
                required />
                <mat-error>Title is required</mat-error>
                <mat-hint align="end">{{ iapData.textData.title?.length || 0 }}/100</mat-hint>
            </mat-form-field>
       
          </div>
        </div>
      </div>
      <div class="row" *ngIf="iapData.textData.sectionName !== 'Disclaimer'">
        <div class="col-md-12">
      <div class="form-group" >
        <mat-form-field>
            <textarea
                matInput
                placeholder="Short Description (Max. 600 Characters)"
                [(ngModel)]="iapData.textData.description"
                name="desc"
                #desc="ngModel"
                required
                maxlength="600" 
            ></textarea>
            <mat-error>Description is required</mat-error>
            <mat-hint align="end">{{ iapData.textData.title?.length || 0 }}/600</mat-hint>
        </mat-form-field>
      </div>
      </div>
      </div>
    </ng-template>
    <ng-container *ngIf="iapData.textData.sectionName !== 'Section2' && iapData.textData.sectionName !== 'Section3'">
      <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
    </ng-container>
    
    <div *ngIf="iapData.textData.sectionName === 'Section2' ||iapData.textData.sectionName === 'Section3'" class="why-invest-section">
      <mat-tab-group>
        <!-- Main Info Tab -->
        <mat-tab label="Main Info">
          <mat-card class="main-card">
            <mat-card-title>Why Invest</mat-card-title>
            <mat-card-content>
              <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
            </mat-card-content>
          </mat-card>
        </mat-tab>
    
        <!-- Tabs for Each Card -->
        <mat-tab *ngFor="let card of iapData.textData.subSections; let i = index" [label]="'Card ' + (i + 1)">
          <mat-card class="card-container">
            <mat-card-title>Card {{ i + 1 }}</mat-card-title>
            <mat-card-content>
         
              <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                      <mat-form-field>
                        <input matInput placeholder="Enter Title" [(ngModel)]="card.title" name="title{{i}}" #cardtitle="ngModel" maxlength="50"
                          required />
                          <mat-error>Title is required</mat-error>
                          <mat-hint align="end">{{ card.title?.length || 0 }}/50</mat-hint>
                      </mat-form-field>
                  
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                <div class="form-group" >
                  <mat-form-field>
                      <textarea
                          matInput
                          placeholder="Short Discription (Max. 300 Characters)"
                          [(ngModel)]="card.description"
                          name="desc{{i}}"
                          #carddesc="ngModel"
                          required
                          maxlength="300"
                      ></textarea>
                      <mat-error>Description is required</mat-error>
                      <mat-hint align="end">{{ card.description?.length || 0 }}/300</mat-hint>

                  </mat-form-field>
                </div>
                </div>
                </div>
              <div class="row">
                 <div class="form-group padding-right-10 col-md-12">
                  <app-file-input
                    *ngIf="!card.iconPath"
                    (fileChange)="onFileChange($event, 'cardFileName' + i)"
                    [(ngModel)]="card.iconPath"
                    name="iconPath{{ i }}"
                    placeholder="Upload Image"
                    required
                  >
                    <button type="button" mat-raised-button color="primary">
                      Choose
                    </button>
                  </app-file-input>
    
                  <ng-template [ngIf]="card.iconPath">
                    <mat-form-field class="full-width">
                      <input
                        disabled
                        matInput
                        placeholder="Image"
                        [(ngModel)]="card.iconPath"
                        name="icon{{ i }}"
                      />
                      <button
                        mat-button
                        matSuffix
                        mat-icon-button
                        type="button"
                        (click)="card.iconPath = ''"
                      >
                        <mat-icon>clear</mat-icon>
                      </button>
                    </mat-form-field>
                  </ng-template>
                  <p class="note">Note: Please upload an image with resolution 84*84</p>
                </div>
              </div>
              <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <mat-form-field>
                    <input matInput placeholder="Enter Sequence " [(ngModel)]="card.sequence" name="cardsequence"
                      #cardsequence="ngModel" (keypress)="allowOnlyNumbers($event)" required />
                  </mat-form-field>
                </div>
              </div>
            </div>
            </mat-card-content>
          </mat-card>
        </mat-tab>
      </mat-tab-group>
    </div>
    
    <div *ngIf="iapData.textData.sectionName === 'Disclaimer'">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <div class="align-h margin-bottom-10">
              <h5 class="margin-bottom-0">Disclaimer Content</h5>
              <span>(description)</span>
            </div>
            <angular-editor [placeholder] [(ngModel)]="iapData.textData.description" name="desc" #desc="ngModel"
              required [config]="editorConfig" maxlength="1500"></angular-editor>
              <mat-hint align="end">{{ iapData.textData.description?.length || 0 }}/1500</mat-hint>
          </div>
        </div>
      </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
          <mat-form-field class="full-width">
            <mat-label>Phone Number</mat-label>
            <input 
              matInput 
              placeholder="1800-266-9603" 
              name="mobile"
              #mobile = "ngModel"
              pattern="^[0-9]{4}-[0-9]{3}-[0-9]{4}$"
              required
              [(ngModel)]="iapData.textData.mobile" 
            />
            <mat-hint>Format: 1800-266-9603</mat-hint>
            <mat-error *ngIf="mobile.errors?.pattern">
              Invalid phone number format. Use 1800-266-9603.
            </mat-error>
            <mat-error *ngIf="mobile.errors?.required">
              Phone number is required.
            </mat-error>
          </mat-form-field>
          </div>
        </div>
        <div class="col-md-6"> 
          <div class="form-group">
            <mat-form-field class="full-width">
              <mat-label>Email ID</mat-label>
              <input 
                matInput 
                placeholder="mfassist@itiorg.com" 
                name="email"
                #email="ngModel"
                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                required
                [(ngModel)]="iapData.textData.email" 
              />
              
              <mat-error *ngIf="email.errors?.pattern">
                Invalid email format. Please use a valid email like mfassist@itiorg.com.
              </mat-error>
              <mat-error *ngIf="email.errors?.required">
                Email is required.
              </mat-error>
            </mat-form-field>
            
          </div>
        </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group" >
              <mat-form-field>
                  <textarea
                      matInput
                      placeholder="Risk Warning (Max. 100 Characters)"
                      [(ngModel)]="iapData.textData.disclaimerAdditionalText"
                      name="Adddesc"
                      #Adddesc="ngModel"
                      required
                      maxlength="100"
                  ></textarea>
                  <mat-hint align="end">{{ iapData.textData.disclaimerAdditionalText?.length || 0 }}/100</mat-hint>

                  <mat-error>Description is required</mat-error>
              </mat-form-field>
            </div>
            </div>
        </div>
        
    </div>
    
  </div>
  <div class="margin-top-20 margin-bottom-20 text-center">
    <button mat-raised-button color="primary" class="mat-button-large" type="submit" [disabled]="!f.valid">
      <span *ngIf="!iapData.id">Submit</span>
      <span *ngIf="iapData.id">Update</span>
    </button>
  </div>

</form>